var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGoal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 169.193,
    x2: 446.372,
    y1: 176.187,
    y2: 453.366
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 420.27,
    x2: 349.887,
    y1: 275.339,
    y2: 188.395
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7acbff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f73a0"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843561"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.898,
    x2: 489.685,
    xlinkHref: "#lg1",
    y1: 157.892,
    y2: 496.679
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.784,
    x2: 376.315,
    xlinkHref: "#lg1",
    y1: 205.778,
    y2: 383.31
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.069,
    x2: 276.206,
    xlinkHref: "#lg1",
    y1: 248.063,
    y2: 283.2
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#843561",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a2f4d"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 452.432,
    x2: 360.106,
    xlinkHref: "#lg2",
    y1: 289.417,
    y2: 197.09
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 411.208,
    x2: 318.882,
    xlinkHref: "#lg2",
    y1: 330.641,
    y2: 238.315
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 373.833,
    x2: 281.506,
    xlinkHref: "#lg2",
    y1: 368.016,
    y2: 275.69
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(.707 .707 -.707 .707 1454.564 391.159)",
    gradientUnits: "userSpaceOnUse",
    x1: -991.823,
    x2: -897.193,
    y1: 706.224,
    y2: 706.224
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc0d5"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffce47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9356"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 277.741,
    x2: 510,
    xlinkHref: "#lg3",
    y1: 116.13,
    y2: 116.13
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 419.358,
    x2: 351.809,
    xlinkHref: "#lg3",
    y1: 146.17,
    y2: 78.621
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(.707 .707 -.707 .707 1454.564 391.159)",
    gradientUnits: "userSpaceOnUse",
    x1: -947.365,
    x2: -923.22,
    y1: 752.553,
    y2: 752.553
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f73a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#174461"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 251.503,
    cy: 258.497,
    fill: "url(#SVGID_1_)",
    r: 205.766
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392.72 55.332s-114.971 114.976-114.98 114.985l-33.207 87.92c-.75 2.098-.204 4.163 1.048 5.604l178.06 178c48.846-45.879 79.365-111.043 79.365-183.344.001-86.552-43.724-157.916-110.286-203.165z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m251.503 6.994c-138.899 0-251.503 112.605-251.503 251.503s112.604 251.503 251.503 251.503 251.503-112.604 251.503-251.503-112.605-251.503-251.503-251.503zm0 443.723c-106.158 0-192.22-86.062-192.22-192.22s86.062-192.22 192.22-192.22 192.22 86.062 192.22 192.22-86.062 192.22-192.22 192.22z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251.503 126.703c-72.784 0-131.794 59.01-131.794 131.794s59.01 131.794 131.794 131.794 131.794-59.01 131.794-131.794-59.01-131.794-131.794-131.794zm0 200.244c-37.808 0-68.449-30.641-68.449-68.449s30.641-68.449 68.449-68.449 68.449 30.641 68.449 68.449-30.641 68.449-68.449 68.449z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.503,
    cy: 258.497,
    fill: "url(#SVGID_5_)",
    r: 26.083
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m462.987 122.331c-21.376-27.151-45.943-50.477-70.263-66.996 0 0-18.035 18.035-39.82 39.82 54.526 33.933 90.819 94.396 90.819 163.342 0 55.942-23.897 106.295-62.04 141.407l41.956 41.944c48.85-45.869 79.367-111.052 79.367-183.352 0-50.178-14.694-96.928-40.019-136.165z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m308.438 139.621c-17.476 17.476-30.704 30.691-30.704 30.691l-8.347 22.109c29.138 7.85 50.564 34.454 50.564 66.077 0 21.773-10.16 41.162-25.996 53.706l44.937 44.925c27.238-24.121 44.403-59.37 44.403-98.631.002-52.39-30.578-97.651-74.857-118.877z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.235 232.563-9.7 25.673c-.745 2.099-.211 4.161 1.043 5.602l17.861 17.861c8.409-4.335 14.147-13.091 14.147-23.201 0-13.489-10.235-24.581-23.351-25.935z",
    fill: "url(#SVGID_8_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m277.74 165.347-26.057 72.89-3.226 20.261c-1.607 4.494 23.306-.181 23.306-.181l72.89-26.057c18.533-18.533-48.38-85.446-66.913-66.913z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506.217 70.705-161.566 161.554c-1.832-3.175-4.616-5.984-8.182-7.975-4.873-2.699-12.493-1.221-17.769.379-1.148.342-2.198-.256-2.626-1.172-.269-.55-.318-1.221-.024-1.881.012 0 .012-.012.012-.012.293-.672.55-1.356.769-2.039.098-.33.195-.659.293-.989.012-.024.012-.037.012-.061.281-1.062.476-2.125.586-3.212.037-.354.061-.72.086-1.075.03-.59.036-1.18.017-1.77-.134-4.129-1.483-8.229-4.047-11.712-.623-.855-1.319-1.661-2.088-2.43-.77-.769-1.575-1.465-2.43-2.088-3.981-2.931-8.768-4.274-13.482-4.03-.354.024-.721.049-1.075.085-1.087.11-2.162.305-3.212.586-.024 0-.037 0-.061.012-.33.098-.66.195-.989.293-.354.11-.696.232-1.038.366-.33.122-.66.256-.989.403-.012 0-.012 0-.024.012-.66.293-1.331.244-1.881-.024-.916-.427-1.514-1.478-1.172-2.626 1.6-5.276 3.077-12.884.379-17.756-1.991-3.578-4.787-6.363-7.975-8.194l161.554-161.566c5.056-5.044 13.238-5.044 18.282 0l9.538 9.538 29.566 29.566 9.538 9.538c5.042 5.042 5.042 13.225-.002 18.28z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496.68 42.886-180.605 180.605c-.269-.55-.318-1.221-.024-1.881.012 0 .012-.012.012-.012.293-.672 1.563-5.227 1.661-6.302.049-.366.073-.72.086-1.075.244-4.714-1.099-9.501-4.03-13.482-.623-.855-1.319-1.661-2.088-2.43-.77-.769-1.575-1.465-2.43-2.088-3.981-2.931-8.768-4.274-13.482-4.03-.354.012-.708.037-1.075.085-1.075.098-2.149.293-3.212.586-.024 0-.037 0-.061.012-.33.085-2.687.916-3.016 1.062-.012 0-.012 0-.024.012-.66.293-1.331.244-1.881-.024l180.603-180.604z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.284 246.716c-3.515-3.515-7.444-6.336-11.601-8.479l-7.15 20.001c-1.607 4.494 2.734 8.835 7.228 7.228l20.001-7.15c-2.142-4.156-4.963-8.085-8.478-11.6z",
    fill: "url(#SVGID_12_)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoal);
export default __webpack_public_path__ + "static/media/icon-goal.f61a1c576fc0651ef5713f6e3a7edfad.svg";
export { ForwardRef as ReactComponent };